<template>
    <div class="table-container pull-auto">
        <div class="avue-crud">
            <avue-crud :data="list.slice((page.currentPage-1)*page.pageSize,page.currentPage*page.pageSize)" :option="tableOption" :page="page"
              @current-change="currentChange" @row-click="showRow">
            <template slot-scope="scope" slot="menuLeft">
                <el-button size="mini" @click="handleCreate" type="primary" icon="el-icon-plus" v-if="roleManager_btn_add">添加
                </el-button>
                <el-button size="mini" type="primary" v-if="roleManager_btn_add" icon="el-icon-edit-outline" @click="handleUpdate1" :disabled="totalState">编辑
                </el-button>
                <el-button :disabled="totalState" size="mini" @click="handleDelete" type="primary" icon="el-icon-circle-close-outline" v-if="roleManager_btn_del">删除
                </el-button>
                <el-button :disabled="totalState" size="mini" @click="handleDealing" type="primary"  icon="el-icon-setting" v-if="roleManager_btn_perm">查看师傅
                </el-button>
            </template>
            <template slot-scope="scope" slot="id">
                <el-radio class="radio" v-model="radio"  :label="scope.row.id"></el-radio>
            </template>
            </avue-crud>
            <!-- 添加  修改 -->
            <!-- 发热问题&groupTips= 提 台湾人ff9ad7d6d2593a858efa4b3217b107eb -->
            <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
                <el-form :model="form" :rules="rules" ref="form" label-width="100px">
                    <el-form-item label="群组名称" prop="groupName" class="el-form-items">
                        <el-input v-model="form.groupName" placeholder="群组名称"></el-input>
                    </el-form-item>
                    <el-form-item label="群组描述" prop="groupTips" class="el-form-items">
                        <el-input v-model="form.groupTips" placeholder="群组描述"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cancel('form')" icon="el-icon-close" size="mini">取 消</el-button>
                    <el-button v-if="dialogStatus=='create'" size="mini" icon="el-icon-success" type="primary"
                                @click="create('form')">确 定
                    </el-button>
                    <el-button v-else type="primary" size="mini" icon="el-icon-edit" @click="update('form')">修 改</el-button>
                </div>
            </el-dialog>
            <!-- 查看工人 -->
            <el-dialog title="查看师傅" :visible.sync="dialogTableVisible">
                 <avue-crud-table :data="gridData" :option="tablegr" @row-click="showRowworker" @search-change="workerSearchChangegr">
                <template slot-scope="scope" slot="menuLeft">
                    <el-button size="mini" @click="handleCreate1" type="primary" v-if="roleManager_btn_add">添加师傅
                    </el-button>
                    <el-button :disabled="totalState1" size="mini" @click="handleDelete1" type="primary" v-if="roleManager_btn_del">移除师傅
                    </el-button>
                </template>
                <template slot-scope="scope" slot="urId">
                    <el-radio class="radio" v-model="radioworker"  :label="scope.row.urId"></el-radio>
                </template>
                </avue-crud-table>
                <div slot="footer" class="dialog-footer">
                    <!-- <el-button size="mini" @click="dialogTableVisible = false">取 消</el-button> -->
                    <!-- <el-button size="mini" type="primary" @click="dialogTableVisible = false">确 定</el-button> -->
                </div>
            </el-dialog>
        </div>
        <worker ref="childworker" @func="getMsgFormSon"></worker>
    </div>

</template>
<script>
    import { fetchList,getObj,addObj,addsObj,putObj,
    delObj, del1Obj,allotObj,fetchDeptTree} from '@/api/admin/groups'
    import {getWorkerList} from '@/api/admin/addProject'
    import {formatSelectTree,dealElement} from '@/util/util'
    import {objKeySort} from '@/util/ajaxsign'
// import { tableOption } from '@/const/crud/employee';
import {getDictList} from '@/api/admin/dict'
import worker from './worker.vue'


    export default {
        name: 'table_role',
        components: {worker},
        data() {
            return {
                permissions : [],
                page: {
                  pageSizes: [10, 20, 50, 100],
                  currentPage: 1,
                  total: 0,
                  pageSize: 10
                },
                listQuery: {
                    current: 1,
                    size: 5,
                    total : 0,
                },
                tableOption : {
                    addBtn : false,
                    refreshBtn : false,
                    columnBtn : true,
                    editBtn : true,
                    delBtn : true,
                    menu : false,
                    page:true,
                    border : true,
                    align:'center',
                    menuAlign:'center',
                    height : window.innerHeight - 290,
                    index:false,
                    column:[
                    {
                        label:'',
                        prop:'id',
                        width:40,
                        solt:true
                    },
                    {
                        label:'群组名称',
                        prop:'groupName',
                        overHidden : true,
                    },{
                        label:'群组描述',
                        prop:'groupTips',
                        overHidden : true,
                    },{
                        label:'群组师傅数',
                        prop:'userCount'
                    },{
                        label:'创建时间',
                        prop:'createTime',
                        type: 'date',
                        format: 'yyyy-MM-dd HH:mm:ss',
                        valueFormat: 'yyyy-MM-dd HH:mm:ss'
                    }
                    ]
                },
                radioworker : '',
                tablegr : {
                    addBtn : false,
                    refreshBtn : false,
                    columnBtn : true,
                    editBtn : true,
                    delBtn : true,
                    menu : false,
                    page:true,
                    border : true,
                    align:'center',
                    menuAlign:'center',
                    height : 500,
                    index:false,
                    column:[{
                    label:'',
                    prop:'urId',
                    width:40,
                    solt:true
                    },
                    {
                    label:'手机号码',
                    prop:'phone',
                    overHidden : true,
                  },
                  {
                    label:'姓名',
                    prop:'name',
                    overHidden : true,
                  },{
                    label:'团队认证',
                    prop:'isForeman',
                    search : true,
                    type:'select',
                    dicData : [{label:'已认证',value:1},{label:'未认证',value:0}],
                    overHidden : true,
                    formatter: function(row){
                        return  row.isForeman ==1? '已认证' : '未认证'
                    }
                  },{
                    label:'工种',
                    prop:'workTypeIds',
                    type:'select',
                    dicData : {},
                    props : {
                        label: 'name',
                        value: 'id'
                    },
                    search : true,
                    overHidden : true
                    },{
                      label:'实名状态',
                      prop:'workerState',
                      formatter: function(row){
                        if(row.workerState == 1){
                          return "审核中";
                        }else if(row.workerState == 2){
                          return "已认证";
                        }else{
                          return "未认证";
                        }
                      }
                    },
                    {
                      label:'群组',
                      prop:'groupNames'
                    }
                  ]
                },
                dic:{
                  workTypes:[],
                  skillTips:[]
                },
                totalState:true,
                totalState1:true,
                radio:'',
                radio1:'',
                radio2:'',
                roleId:'',
                rid:'',
                groupname : '',
                rids:'',
                uids:'',
                cr:'',
                treeData: [],
                treeDeptData: [],
                menuIds: [],
                checkedKeys: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                list: [],
                gridData:[],
                gridData1:[],
                account: undefined,
                name: undefined,
                roleDept: undefined,
                total: 0,
                listLoading: true,
                form: {

                },
                roleCode: undefined,
                datainfo :'',
                rules: {
                    roleName: [
                        {
                            required: true,
                            message: '群组名称',
                            trigger: 'blur'
                        },
                        {
                            min: 3,
                            max: 20,
                            message: '长度在 3 到 20 个字符',
                            trigger: 'blur'
                        }
                    ],
                    roleCode: [
                        {
                            required: true,
                            message: '角色标识',
                            trigger: 'blur'
                        },
                        {
                            min: 3,
                            max: 20,
                            message: '长度在 3 到 20 个字符',
                            trigger: 'blur'
                        }
                    ],
                    roleDesc: [
                        {
                            required: true,
                            message: '群组描述',
                            trigger: 'blur'
                        },
                        {
                            min: 3,
                            max: 20,
                            message: '长度在 3 到 20 个字符',
                            trigger: 'blur'
                        }
                    ]
                },
                statusOptions: ['0', '1'],
                rolesOptions: undefined,
                dialogFormVisible: false,
                dialogDeptVisible: false,
                dialogPermissionVisible: false,
                dialogTableVisible: false,
                dialogTableVisible1: false,
                dialogStatus: '',
                textMap: {
                    update: '编辑',
                    create: '创建群组',
                    permission: '分配权限'
                },
                currentRow: [],
                tableKey: 0,
                urId : '',
                roleManager_btn_add: false,
                roleManager_btn_edit: false,
                roleManager_btn_del: false,
                roleManager_btn_perm: false,
                normalizer(node) {
                    // debugger
                    return {
                        id: node.id,
                        label: node.name
                    }
                }
            }
        },
        created() {
            this.getList();
            this.initDic();
            this.permissions = JSON.parse(window.sessionStorage.getItem("userInfo")).permissions;
            for(var i=0;i<this.permissions.length;i++){
                if(this.permissions[i] == 'sys_worksgroup_edit'){
                    this.roleManager_btn_add = this.permissions[i]
                }
                if(this.permissions[i] == 'sys_worksgroup_delete'){
                    this.roleManager_btn_del = this.permissions[i]
                }
                if(this.permissions[i] == 'sys_worksgroup_show'){
                    this.roleManager_btn_perm = this.permissions[i]
                }
            }
            getDictList(objKeySort({code:"worktype"})).then(response => {
                  this.dic.workTypes = response.data.data.worktype;
                  this.tablegr.column[4].dicData =response.data.data.worktype
              })
        },
        methods: {
            showRow(row){
                this.totalState = false;
                this.datainfo = row;
                this.radio = row.id;
                this.groupname = row.groupName;
            },
            showRowworker(row){
                this.radioworker = row.urId;
                this.urId=row.urId;
                if(row){
                  this.totalState1 = false;
                }
            },
            sizeChange(val) {
              this.listQuery.size = val;
              this.page.pageSize = val;
              this.listQuery.current = 1;
              this.getList()
            },
            currentChange(val) {
              this.listQuery.current = val;
              this.page.currentPage = val;
              this.getList()
            },
            // 提交搜索
            searchChange(){
                this.getList();
            },
            //清空收缩条件
            searchReset(){
              this.form={};
              this.listQuery.current = 1;
              this.listQuery.size = 10;
              this.getList();
            },

            handleCurrentChange1(val) {
                this.totalState=false;
                this.radio = val.roleId;
                console.log(val)
                this.currentRow = val;
                this.rid = val.roleId;
                this.cr = val
                this.$emit('data',val.pkg);
                console.log(this.roleId=val.roleId)
            },
            getCurrentRow(val){
                console.log(val)
            },
            initDic(){
              getDictList(objKeySort({code:"worktype"})).then(response => {
                  this.dic.workTypes = response.data.data.worktype;
              })
               getDictList(objKeySort({code:"worker_skill"})).then(response => {
                  this.dic.skillTips = response.data.data.worker_skill;
              })
            },
            handleCurrentChange2(val) {
                this.currentRow = val;
                this.rids = val.id;
                this.uids=val.deptId;
                this.uidss=val.urId;
                this.cr = val
                this.$emit('data',val.pkg);
                console.log(this.rids=val.id)
                console.log(this.uids=val.deptId)
            },
            getCurrentRow1(val){
                console.log(val)
            },
             //刷新列表操作
            formatterWorkType(workTypeIds){
                var  workTypeNames = '';
                if(workTypeIds&&workTypeIds.length>0){
                    workTypeIds.split(",").forEach(workerTypeId =>{
                        if(this.dic.workTypes){
                            this.dic.workTypes.forEach(workerType => {
                                if(workerType.id==workerTypeId){
                                    workTypeNames = workTypeNames + workerType.name +',';
                                }
                            })
                        }else{
                            return workTypeIds;
                        }

                    })
                }
                if(workTypeNames.length>0){
                    workTypeNames = workTypeNames.substring(0,workTypeNames.length-1);
                }
                return  workTypeNames;
            },
              //刷新列表操作
            formatterskillTips(skillTips){
                var  workTypeNames = '';
                if(skillTips&&skillTips.length>0){
                    skillTips.split(",").forEach(skillTipID =>{
                        if(this.dic.skillTips){
                            this.dic.skillTips.forEach(skillTip => {
                                if(skillTip.id==skillTipID){
                                    workTypeNames = workTypeNames + skillTip.name +',';
                                }
                            })
                        }else{
                            return skillTips;
                        }

                    })
                }
                if(workTypeNames.length>0){
                    workTypeNames = workTypeNames.substring(0,workTypeNames.length-1);
                }
                return  workTypeNames;
            },
            getList() {
                this.listLoading = true
                var data = {
                    pageNum: this.listQuery.current,
                    pageSize: this.listQuery.size,
                    state : this.form.state,
                    condition : this.form.condition
                }
                fetchList(objKeySort(data)).then(response => {
                    if(response.data.code==200&&response.data.data){
                       this.list = response.data.data
                       this.page.total = response.data.data.length
                    }
                    this.listLoading = false
                })
            },

            // 添加
            handleCreate() {
                this.resetTemp()
                this.dialogStatus = 'create'
                this.dialogFormVisible = true
            },

            // 添加确定
            create() {
              let that=this
              if(that.form.groupName&&that.form.groupName.trim()){
                that.form.groupName=that.form.groupName.trim()
                addObj(objKeySort(that.form)).then(response => {
                    if(response.data.code==200){
                      that.dialogFormVisible = false
                      that.getList()
                      that.$message({
                          title: '成功',
                          message: '创建成功',
                          type: 'success',
                          duration: 2000
                      })
                    }
                })
              }else{
                that.$message({
                    title: '温馨提示',
                    message: '群组名称必须填写',
                    type: 'warning',
                    duration: 2000
                })
              }

             // location.reload()
            },
            // 编辑
            handleUpdate1(row) {
                console.log(row.deptName)
                this.dialogFormVisible = true
                this.dialogStatus = 'update'
                console.log(objKeySort({groupId:this.radio}))
                getObj(objKeySort({groupId:this.radio})).then(response => {
                    this.form = response.data.data
                    this.form.deptName = row.deptName
                    this.form.roleDeptId = row.roleDeptId
                })
            },
            // 编辑修改
            update() {
              let that=this
              if(that.form.groupName.trim()){
                putObj(objKeySort(dealElement({groupId:this.radio,groupTips:this.form.groupTips,groupName:this.form.groupName.trim()}))).then(response => {
                  if(response.data.code==200){
                    this.dialogFormVisible = false
                    this.getList()
                    this.$message({
                        title: '成功',
                        message: '修改成功',
                        type: 'success',
                        duration: 2000
                    })
                  }
                })
              }else{
                that.$message({
                    title: '温馨提示',
                    message: '群组名称必须填写',
                    type: 'error',
                    duration: 2000
                })
              }
            },
            // 查看工人
            handleDealing(){
                this.dialogTableVisible=true
                getWorkerList(objKeySort(dealElement({groupId:this.radio}))).then(response => {
                    this.gridData =response.data.data;
                    this.gridData.forEach(data =>{
                        data.workTypeIds = this.formatterWorkType(data.workTypeIds);
                    })
                })
                // location.reload()
            },
             //搜索工人信息
            workerSearchChangegr(params){
                this.searchgr = {
                    condition : params.condition,
                    groupId : this.radio,
                    isForeman : params.isForeman,
                    workTypeId : params.workTypeIds
                }
                getWorkerList(objKeySort(dealElement(this.searchgr))).then(response => {
                    this.gridData =response.data.data;
                    this.gridData.forEach(data =>{
                        data.workTypeIds = this.formatterWorkType(data.workTypeIds);
                    })
                })
            },

            handleCreate1() {
                let that=this
                let _workids=[]
                that.gridData.forEach(item=>{
                  _workids.push(item.id)
                })
                sessionStorage.setItem("workIds",JSON.stringify({
                  workIds:_workids
                }))
                that.$refs.childworker.setsataus(that.radio,that.list,that.groupname);
            },
            // 查看工人 确定
            creates() {
                addsObj(objKeySort({groupId:this.rids,urIds:this.uidss})).then(() => {
                    this.dialogTableVisible1 = false
                    this.getList()
                    this.$message({
                        title: '成功',
                        message: '添加成功',
                        type: 'success',
                        duration: 2000
                    })
                })
                .then(()=>{
                    allotObj(objKeySort({groupId:this.rids})).then(response => {
                        this.gridData = response.data.data
                        this.total = response.data.data.total
                        this.listLoading = false
                    })
                })
                // location.reload()
            },
            /**
             * 解析出所有的叶子节点id
             * @param json 待解析的json串
             * @param idArr 原始节点数组
             * @param temp 临时存放节点id的数组
             * @return 叶子节点id数组
             */
            resolveAllLeafNodeId(json, idArr, temp) {
                for (let i = 0; i < json.length; i++) {
                    const item = json[i]
                    // 存在子节点，递归遍历;不存在子节点，将json的id添加到临时数组中
                    if (item.children && item.children.length !== 0) {
                        this.resolveAllLeafNodeId(item.children, idArr, temp)
                    } else {
                        temp.push(idArr.filter(id => id === item.id))
                    }
                }
                return temp
            },
            async handleDept() {
                fetchDeptTree(objKeySort({})).then(response => {
                    this.treeDeptData = formatSelectTree(response.data.data)
                    this.dialogDeptVisible = true
                })
                },
            filterNode(value, data) {
                if (!value) return true
                return data.label.indexOf(value) !== -1
            },
            getNodeData(data) {
                this.dialogDeptVisible = false
                this.form.roleDeptId = data.id
                this.form.deptName = data.name
                console.log(data)
            },
            // 删除
            handleDelete() {
                this.$confirm('确定将'+this.datainfo.groupName+'群组删除?', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delObj(objKeySort({groupId:this.radio})).then(response => {
                        if (response.status === 200) {
                            this.dialogFormVisible = false
                            this.getList()
                            this.$message({
                                title: '成功',
                                message: response.data.msg,
                                type: 'success',
                                duration: 2000
                            })
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleDelete1() {
                 this.$confirm('确定将此师傅移除该群组?', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    del1Obj(objKeySort({groupId:this.radio,urIds:this.urId})).then(response => {
                        if (response.status === 200) {
                            this.getList()
                            this.$message({
                            title: '成功',
                            message: '删除成功',
                            type: 'success',
                            duration: 2000
                            })
                            let mdata = {
                              condition : "",
                              groupId :  "",
                              isForeman :  "",
                              workTypeId :  "",
                            }
                            this.workerSearchChangegr(mdata)
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 取消
            cancel(formName) {
                this.dialogFormVisible = false
                this.$refs[formName].resetFields()
            },
            resetTemp() {
                this.form = {

                }
            },
            resetTemp1() {
                this.form = {

                }
            },
            getMsgFormSon(data){
                if(data=="refresh"){
                  let mdata = {
                      condition : "",
                      groupId :  "",
                      isForeman :  "",
                      workTypeId :  "",
                  }
                  this.workerSearchChangegr(mdata)
                }
             }
        }
    }
</script>
<style lang="scss" scoped>
    .el-table{
        margin-top:22px;
    }
    .el_s_left{
        float:left
    }
    .el_btn{
        clear:both;
    }

    .filter-item1{
        width: auto;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        border: 0!important;
        margin-left: 0!important;
        margin-right: 22px;
    }

    .sh_tip{
        vertical-align:top;
        display:inline-block
    }
    .lf_item span:first-child{
        display:inline-block;
        width:100px;
        vertical-align:top;
    }
    .el-form-items{
        float: left;
        width: 48%!important;
    }
    .el-form-itemss{
        width: 300px!important;
        height: 40px!important;
        background-attachment: #fff!important;
    }
    .el-form-itemss .el-input{
        outline: none!important;
    }
    .el-f-item{
        width: 100%!important;
    }
    .el-dialog__header{
        margin-bottom: 0px;
    }
    .el-tag{
        border: 0!important;
        color: #666!important;
        background-color: transparent;
        font-size:14px;
    }
    .dialog-footer{
        margin-left: 0!important;
    }
    .is-required{

    }
    /*.select_role{
        -height:100px;
    }*/
    .el-dialog__footer{
        -height:120px;
    }
    .p1{
        width:100% !important;
    }
    .part{
        position: relative;
    }
    /*.el-table /deep/ .el-radio{

    }*/
    .el-table /deep/ .el-table__row:nth-child(even) {
        background-color: #F6F9FF !important;
    }
    .nobtn{
        display: none;
    }
</style>
